define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/one_two_pay_form"
], function($, _, Marionette, CommonView, OneTwoPayForm) {
    return CommonView.extend({

        ui: _.extend(CommonView.prototype.ui, {
            'currencySelect':'#currency_abbr',
            'bankSelect':'#bank_code',
            'amount' : '#amount'
        }),

        events: _.extend(CommonView.prototype.events, {
            'keyup @ui.amount': 'updateUsdAmount',
        }),

        initialize: function(){
            this.bindUIElements();
            this.form = new OneTwoPayForm();
        },

        updateUsdAmount: function() {
            $('#usd_amount').text( "$ "+ ($('#amount').val()*window.fx_rates).toFixed(2));
        },
    });
});
